import script from "./SharedSpinner.vue?vue&type=script&setup=true&lang=js"
export * from "./SharedSpinner.vue?vue&type=script&setup=true&lang=js"

import "./SharedSpinner.vue?vue&type=style&index=0&id=47ecf071&lang=scss"

const __exports__ = script;

export default __exports__